import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <motion.nav
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled ? "bg-[#F5F1EA]/90 backdrop-blur-xl border-b border-black/5" : ""
      }`}
      data-testid="nav-main"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-4 md:py-5 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-3" data-testid="nav-logo" aria-label="Santi Lorenzo · Método SIRCS">
          <img
            src="https://customer-assets.emergentagent.com/job_sircs-test/artifacts/e5ti8jys_Photoroom_20260621_143416.png"
            alt="SIRCS — Santi Lorenzo"
            className="h-12 sm:h-14 w-auto"
            style={{ filter: "brightness(0.15) saturate(1.2)" }}
          />
        </a>
        <a
          href="#reservar"
          className="btn-gold text-xs px-5 py-3 sm:px-7 sm:py-3.5"
          data-testid="nav-cta"
        >
          Avísame de la próxima
        </a>
      </div>
    </motion.nav>
  );
}
